module.exports = __webpack_public_path__ + "static/media/API_Ref.569748bd.png";